// authActions.js
import * as authService from '../../services/loginServices';
import {
    START_LOADING,
    STOP_LOADING
} from "./actionTypes";
import { closeSessionTimeoutModal } from './sessionTimeOutActions';

export const signUp = (formData) => async (dispatch) => {
  try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = await authService.signUp(formData);
      sessionStorage.setItem('token', token);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SIGN_UP_SUCCESS', payload: sessionStorage.getItem("token") });
  } catch (error) {
      const errorMessage = error?.errors?.[0]?.errorMessage || 'An unknown error occurred.';
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SIGN_UP_FAILURE', payload: errorMessage });
  }
};

export const clearAuthError = () => ({
  type: 'CLEAR_AUTH_ERROR',
});

export const signOut = () => async (dispatch) => {
    await dispatch({ type: 'SIGN_OUT_SUCCESS', payload: null });
};

export const signIn = (formData) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING, service: 'SIGN_IN' });
       dispatch({ type: "CLEAR_USER_INFO_SUCCESS" });
    const token = await authService.signIn(formData);
    sessionStorage.setItem('token', token);
    dispatch({ type: STOP_LOADING, service: 'SIGN_IN' });
    dispatch({ type: 'SIGN_IN_SUCCESS', payload: sessionStorage.getItem('token') });
    dispatch(closeSessionTimeoutModal());
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'SIGN_IN' });

    let errorMessage = 'You have entered wrong User Id & Password';
    let errorDetails = null;
    if (error?.errors && Array.isArray(error.errors) && error.errors.length > 0) {
      const firstError = error.errors[0];
      errorMessage = firstError.errorMessage;

      // Include target information if needed
      if (firstError.target) {
        errorDetails = {
          message: firstError.errorMessage,
          target: firstError.target
        };
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }

    dispatch({ type: 'SIGN_IN_FAILURE', payload: errorMessage });

    // Throw error with details
    const errorToThrow = new Error(errorMessage);
    if (errorDetails) {
      errorToThrow.details = errorDetails;
    }
    throw errorToThrow;
  }
};

// export const refreshToken = () => async (dispatch, getState) => {
//     try {
//       // dispatch({ type: START_LOADING, service: 'START_LOADING' });
//       const token = getState().auth.token ||sessionStorage.getItem("token");
//       const response = await authService.refreshTokenServices(token);
//       return response;
//       dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
//     } catch (error) {

//     }
//   };

export const refreshToken = () => async (dispatch, getState) => {
  try {
    // Get current token from Redux state or session storage
    const token = getState().auth.token || sessionStorage.getItem("token");

    // Call the refresh token service
    const response = await authService.refreshTokenServices(token);

    // If we have a successful response with a new token
    if (response) {
      // Update the token in Redux store
      dispatch({
        type: 'REFRESH_TOKEN_SUCCESS',
        payload: response
      });

      // Also update the token in session storage
      sessionStorage.setItem("token", response);

      // Stop loading (appears at the end in your original code)
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

      // Return the response for chaining
      return response;
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    // If token refresh fails, you might want to sign out the user
    dispatch(signOut());

    // Re-throw the error for proper error handling
    throw error;
  }
};